<template>
  <div class="page">
    <div class="box">
      <div class="title">物流信息</div>

      <div class="section">
        <div class="section-title">卡密信息</div>
        <div class="info-row"><span class="label">卡号</span><span class="mono">{{ cardNo }}</span></div>
        <div class="info-row"><span class="label">卡密</span><span class="mono">{{ cardKey || '-' }}</span></div>
        <div class="info-row"><span class="label">套餐</span><span>{{ pkg || '-' }}</span></div>
      </div>

      <div class="section">
        <div class="section-title">收货信息</div>
        <div class="info-row"><span class="label">收件人</span><span>{{ name || '-' }}</span></div>
        <div class="info-row"><span class="label">手机号</span><span>{{ phone || '-' }}</span></div>
        <div class="info-row"><span class="label">收货地址</span><span>{{ fullAddr || '-' }}</span></div>
        <div class="info-row"><span class="label">备注</span><span>{{ remark || '-' }}</span></div>
      </div>

      <div v-if="shipments.length > 0">
        <div v-for="(s, idx) in shipments" :key="s.id || idx" class="shipment-block">
          <div class="section-title">快递 {{ shipments.length > 1 ? '#' + (idx + 1) : '' }}</div>
          <div class="info-row"><span class="label">快递公司</span><span>{{ s.expName || courierLabel(s.courierType) || '-' }}</span></div>
          <div class="info-row"><span class="label">快递单号</span><span class="tracking-no">{{ s.logistics }}</span></div>
          <div class="info-row"><span class="label">物流状态</span><span :class="shipClass(s)">{{ s.statusStr || '已发货' }}</span></div>

          <div v-if="s.traces && s.traces.length" class="timeline-wrap">
            <div class="timeline">
              <div class="timeline-item" v-for="(t, tIdx) in s.traces" :key="tIdx" :class="{ latest: tIdx === 0 }">
                <div class="timeline-dot"></div>
                <div class="timeline-content">
                  <div class="timeline-time">{{ t.time }}</div>
                  <div class="timeline-text">{{ t.desc }}</div>
                </div>
              </div>
            </div>
          </div>
          <p v-else-if="s.error" class="error-tip">{{ s.error }}</p>
          <p v-else class="empty-tip">暂无物流轨迹，请稍后查看</p>
        </div>
      </div>

      <div v-if="!shipments.length && !loading" class="section">
        <div class="section-title">订单快递</div>
        <p class="empty-tip">暂未发货</p>
      </div>

      <button @click="$router.replace('/')">返回首页</button>
    </div>
  </div>
</template>

<script>
import { api } from '@/utils/api';
import { courierLabel } from '@/utils/courier';

export default {
  name: 'LogisticsPage',
  data() {
    return {
      cardNo: '',
      cardKey: '',
      shipStatus: '',
      name: '',
      phone: '',
      pkg: '',
      province: '',
      city: '',
      detailAddr: '',
      remark: '',
      shipments: [],
      loading: true
    };
  },
  computed: {
    fullAddr() {
      const parts = [this.province, this.city, this.detailAddr].filter(Boolean);
      return parts.join(' ') || '-';
    }
  },
  async created() {
    const cardNo = this.$route.query.cardNo || '';
    if (cardNo) {
      try {
        const data = await api.get('/api/logistics/' + cardNo);
        if (data.code === 200) {
          this.cardNo = data.data.cardNo || cardNo;
          this.cardKey = data.data.cardKey || '';
          this.shipStatus = data.data.shipStatus || '';
          this.name = data.data.name || '';
          this.phone = data.data.phone || '';
          this.pkg = data.data.pkg || '';
          this.province = data.data.province || '';
          this.city = data.data.city || '';
          this.detailAddr = data.data.detailAddr || '';
          this.remark = data.data.remark || '';
          this.shipments = data.data.shipments || [];
        }
      } catch { /* ignore */ }
    }
    this.loading = false;
  },
  methods: {
    courierLabel(type) {
      return courierLabel(type);
    },
    shipClass(s) {
      if (s.statusStr && s.statusStr.includes('签收')) return 'delivered';
      if (s.statusStr) return 'shipping';
      return 'shipping';
    }
  }
};
</script>

<style scoped>
.page {
  min-height: 100vh;
  padding: 20px 15px;
}
.box {
  max-width: 420px;
  margin: 0 auto;
  background: #fff;
  padding: 25px 20px;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.06);
  border-top: 5px solid var(--color-primary);
}
.title {
  text-align: center;
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 20px;
  color: #1a1a1a;
  letter-spacing: 1px;
}
.section, .shipment-block {
  margin-bottom: 20px;
}
.section-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--color-primary);
  margin-bottom: 10px;
  padding-bottom: 6px;
  border-bottom: 1px solid var(--color-primary-soft);
}
.info-row {
  display: flex;
  padding: 6px 0;
  font-size: 14px;
  color: #333;
}
.info-row .label {
  flex-shrink: 0;
  width: 70px;
  color: #999;
}
.mono {
  font-family: 'SF Mono', 'Menlo', monospace;
  font-size: 13px;
  color: #555;
}
.tracking-no {
  color: var(--color-primary);
  font-weight: 600;
  letter-spacing: 0.5px;
}
.shipping { color: #e67e22; font-weight: 600; }
.delivered { color: var(--color-primary); font-weight: 600; }

.timeline-wrap {
  margin-top: 10px;
}
.timeline {
  position: relative;
  padding-left: 16px;
}
.timeline::before {
  content: '';
  position: absolute;
  left: 4px;
  top: 8px;
  bottom: 8px;
  width: 2px;
  background: #e0e0e0;
}
.timeline-item {
  position: relative;
  padding: 10px 0 10px 16px;
}
.timeline-item:last-child {
  padding-bottom: 0;
}
.timeline-dot {
  position: absolute;
  left: -12px;
  top: 14px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #ddd;
  border: 2px solid #fff;
  box-shadow: 0 0 0 1px #ddd;
}
.timeline-item.latest .timeline-dot {
  background: var(--color-primary);
  box-shadow: 0 0 0 3px rgba(var(--color-primary-rgb), 0.2);
}
.timeline-content {
  font-size: 13px;
}
.timeline-time {
  color: #999;
  font-size: 12px;
  margin-bottom: 2px;
}
.timeline-text {
  color: #333;
  line-height: 1.5;
}
.timeline-item.latest .timeline-text {
  color: var(--color-primary);
  font-weight: 500;
}

.empty-tip {
  text-align: center;
  color: #bbb;
  font-size: 14px;
  margin: 12px 0;
}
.error-tip {
  text-align: center;
  color: #e74c3c;
  font-size: 14px;
  margin: 12px 0;
}

button {
  width: 100%;
  padding: 14px;
  background: linear-gradient(135deg, var(--color-primary-light), var(--color-primary));
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 17px;
  font-weight: 600;
  margin-top: 5px;
  cursor: pointer;
  box-shadow: 0 4px 15px var(--color-primary-shadow);
  transition: all 0.2s ease;
}
button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px var(--color-primary-shadow-hover);
}
</style>
